import type { TMessages } from '@/types/TMessages'

export const messages = {
  text: 'Ввод номера телефона подтверждает ваше согласие с {link}',
  link: 'политикой обработки персональных данных',
} satisfies TMessages
